import { render, staticRenderFns } from "./AthleteScoutingReportsCard.vue?vue&type=template&id=f8ecd174&scoped=true&"
import script from "./AthleteScoutingReportsCard.vue?vue&type=script&lang=ts&"
export * from "./AthleteScoutingReportsCard.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteScoutingReportsCard.vue?vue&type=style&index=0&id=f8ecd174&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ecd174",
  null
  
)

export default component.exports